import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

const BIG_RED_BUTTON_CLASS = 'theme-big-red-button';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  enableBigRedButtonTheme(): void {
    this.getBody()?.classList.add(BIG_RED_BUTTON_CLASS);
  }

  disableBigRedButtonTheme(): void {
    this.getBody()?.classList.remove(BIG_RED_BUTTON_CLASS);
  }

  isBigRedButtonThemeActive(): boolean {
    return this.getBody()?.classList.contains(BIG_RED_BUTTON_CLASS) ?? false;
  }

  private getBody(): HTMLElement | null {
    return this.document?.body ?? null;
  }
}
